import i18n from "../i18n";

/** Map languagesAI codes → existing i18n keys (english, french, …). */
const LANGUAGE_I18N_KEYS: Record<string, string> = {
    FR: "french",
    EN: "english",
    ES: "spanish",
    DE: "german",
    IT: "italian",
    PT: "portuguese",
    RU: "russian",
    NL: "dutch",
    PL: "polish",
    DA: "danish",
    SV: "swedish",
    NO: "norwegian",
    EL: "greek",
    GR: "greek",
    HE: "hebrew",
    AR: "arabic",
    KR: "korean",
    JP: "japanese",
    CN: "chinese",
    ZH: "chinese",
    ZN: "chinese",
};

const sentenceCaseLanguage = (name: string, uiLang: string): string => {
    if (!name) return name;
    // FR / ES / PT: language names are not capitalized mid-sentence ("en français", "en anglais")
    if (/^(fr|es|pt)/i.test(uiLang)) {
        return name.charAt(0).toLowerCase() + name.slice(1);
    }
    return name;
};

const resolveLanguageLabel = (match: { label: string; code: string }, t: any): string => {
    const code = String(match.code || "").toUpperCase();
    const key = LANGUAGE_I18N_KEYS[code];
    if (key) {
        const translated = t(key);
        // If key missing, i18next often returns the key itself
        if (translated && translated !== key) return translated;
    }
    return match.label;
};

/** Mid-sentence "en {{language}}" / "in {{language}}" suffix for page titles. */
export const idToLanguage = (
    id: string,
    languagesAI: {
        value: string;
        label: string;
        code: string;
    }[],
    t: any,
    options?: { titleCase?: boolean },
): string | null => {
    const match = languagesAI.find((lang) => lang.value === id || lang.code === id);
    if (!match) return null;

    const uiLang = (typeof t?.i18n?.language === "string" && t.i18n.language) || i18n.language || "";
    const rawLabel = resolveLanguageLabel(match, t);
    const language = options?.titleCase ? rawLabel : sentenceCaseLanguage(rawLabel, uiLang);

    return t("inLanguage", { language });
};
